import React from 'react'
import './SingleCountryShimmer.css'

const SingleCountryShimmer = () => {
  return (
    <div className='mainDiv'>
        <div className='imgArea'></div>
        <div className='textAreaOne'>
            <div className ='Heading'></div>
            <div className='para'></div>
            <div className='para'></div>
            <div className='para'></div>
            <div className='para'></div>
        </div>
    </div>
  )
}

export default SingleCountryShimmer
